import { render } from "./AIInterviewRecord.vue?vue&type=template&id=b180ecc6&scoped=true"
import script from "./AIInterviewRecord.vue?vue&type=script&lang=js"
export * from "./AIInterviewRecord.vue?vue&type=script&lang=js"

import "./AIInterviewRecord.vue?vue&type=style&index=0&id=b180ecc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b180ecc6"]])

export default __exports__